import { PbxHttpClient } from "@/services/httpclient";

const exportList = {
  testReport: {
    title: "Reporte de evaluaciones",
    path: "/quality/export/evaluation/detaill/",
  },
  accumulatedIndicators: {
    title: "Reporte de Indicadores Acumulados",
    path: "/reports/tail_new_xls",
  },
  cdr: {
    title: "Reporte de CDR",
    path: "/export/cdr_customer",
  },
  cdrFiltered: {
    title: "Reporte de CDR Filtrado",
    path: "/day/export/agentall",
  },
  reportCalls: {
    title: "Reporte de Informe de Llamada",
    path: "/export/info_call_customer",
  },
  productivityReport: {
    title: "Reporte de Productividad",
    path: "/export/sumary_history",
  },
  ShowBreaks: {
    title: "Pausas - Reporte Resumido",
    path: ["export/userPause_Resumen", "export/userPause"],
  },
  CampaignDetails: {
    title: "Detalles de campaña",
    path: "/campaign/campaign-download",
  },
  queue: {
    title: "Informe de colas",
    path: "/reports/infoQueue-download",
  },
  contacts: {
    title: "Contactos",
    path: "/contacts/export/all",
  },
  cdrWhatsapp: {
    title: "CDR WhatsApp",
    path: "/ticket/chat_export/",
  },
  cdrWhatsapp: {
    title: "Historial",
    path: "/krystalos/agenda/export",
  },
  ReportCallbacks: {
    title: "Reporte - Devoluciones de llamadas",
    path: "/callbacks/export",
  },
  ReportCdrChat: {
    title: "CDR Chat",
    path: "/export/ticket/chat_export",
  },
  appointments: {
    title: "Citas",
    path: "/module_appointment/appointments/report_xls",
  },
};

export default async (payload, moduleName) => {
  // eslint-disable-next-line no-useless-catch
  try {
    let res = null;
    const path = exportList[moduleName].path;

    if (moduleName === "productivityReport")
      res = await PbxHttpClient.get(path, {
        responseType: "blob",
        params: payload,
      });
    else if (moduleName === "ShowBreaks")
      res = await PbxHttpClient.get(path[payload.type], {
        responseType: "blob",
        params: payload.payload,
      });
    else if (moduleName === "contacts")
      res = await PbxHttpClient.get(path, {
        responseType: "blob",
      });
    else if (moduleName === "cdrWhatsapp")
      res = await PbxHttpClient.get(path + payload.payload.idticket, {
        responseType: "blob",
      });
    else if (moduleName === "ReportCallbacks")
      res = await PbxHttpClient.get(path + `?date_from=${payload.start}&date_to=${payload.end}`, {
        responseType: "blob",
      });
    else if (moduleName === "testReport")
      res = await PbxHttpClient.get(path + payload.id + `?start=${payload.start}&end=${payload.end}`, {
        responseType: "blob",
      });
    else if (moduleName === "appointments")
      res = await PbxHttpClient.get(path + `?start_date=${payload.start}&end_date=${payload.end}`, {
        responseType: "blob",
      });
    else if (moduleName === "ReportCdrChat") {
      res = await PbxHttpClient.post(
        path, 
        { 
          date_in: payload.start, 
          date_end: payload.end 
        }, 
        { 
          responseType: "blob" 
        }
      );
    }
    // else if (moduleName === "appointments") {
    //   res = await PbxHttpClient.post(
    //   path,
    //   {
    //     start_date: payload.start,
    //     end_date: payload.end,
    //   },
    //   {
    //     responseType: "blob",
    //   }
    // );
    // }
    else
      res = await PbxHttpClient.post(path, payload, {
        responseType: "blob",
      });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${exportList[moduleName].title}.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    throw err;
  }
};
